<template>
    <div class="falcon-chart" :class="locked? 'locked': ''" ref="chart">

    </div>
</template>


<script>
    import Chart from 'chart.js';
    import {CHART_COLORS, FONT_FAMILY} from "./chartColors";
    import {formatDollars, formatDollarsNoZeros, formatMillionsDollars} from "../../moneyUtils";
    import echarts from "echarts";
    import {xAxisStyle} from "@/shared/components/charts/charts-utils";

    export default {
        name: 'StepupGraph',
        data() {
            return {
                graphData: this.data
            }
        },
        props: ['data', 'title', 'color', 'locked'],
        mounted() {

            var myChart = echarts.init(this.$refs['chart'], null, {
                   renderer: 'svg'
            });

            // specify chart configuration item and data
            var option = {
                tooltip: {
                    show: false,
                  // trigger: 'axis'
                },
                textStyle: {
                    fontFamily: FONT_FAMILY
                },
                barWidth: 70,

                xAxis: {
                    axisLine: {
                        lineStyle: {
                            color: '#899094'
                        },
                    },
                    axisTick: {
                        show: false,
                    },
                    axisLabel: {
                        fontSize: 12
                    },
                    tickOptions: {showGridLine: false},
                    type: 'category',
                    data:  [xAxisStyle(formatDollarsNoZeros(this.graphData.technology)  + '\nTechnology'),
                      xAxisStyle(formatDollarsNoZeros(this.graphData.market)  + '\nMarket'),
                      xAxisStyle(formatDollarsNoZeros(this.graphData.execution)  + '\nExecution'),
                      xAxisStyle(formatDollarsNoZeros(this.graphData.financial)   + '\nFinancial')]
                },
                yAxis: {
                    axisLabel: {
                        show: false,
                        color: '#899094',
                        formatter: formatMillionsDollars
                    },
                    axisTick: {
                        show: false,
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#fff'

                        },
                    },
                    splitLine: {
                        lineStyle: {
                            color: ['#E3E9EA'],
                        }
                    },
                },
                series: [

                    {
                        type: 'bar',
                        name: '',
                        data: [
                            this.graphData.technology, this.graphData.market, this.graphData.execution, this.graphData.financial
                        ],
                        itemStyle: {
                            color: this.color,
                            barBorderRadius: [5, 5, 0, 0]
                        },
                    }
                ]
            };

            myChart.setOption(option);
        },
        methods: {},
        computed: {},
    }
</script>

<style scoped>
    .falcon-chart {
        width: 100%;
        height: 400px;
    }
</style>
